<template>
  <div class="newsHomeContent">
    <div class="row">
        <div class="col-md-12">
            <h2>{{newsOrder[selected].name}}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-9"></div>
        <dropdown-order :name="'newsOrdering'" :order="newsOrder"></dropdown-order>
    </div>
    <div class="row">
        <div class="newslist_wrap">
            <div class="col-md-12" v-if="id && id.Items">
                <div v-for="(news, idx) of id.Items" :key="idx" class="col-md-6">
                    <div class="news_box_left">
                        <div v-if="selected==4" class="news_box_img"><a :href="'news_content?id='+news.ID" @click="checkDate(news)"><img class="newsImg" :src="news.ImageURL" :alt="news.Title" /></a></div>
                        <div v-if="selected==4" class="news_title" :title="news.Title"><a :href="'news_content?id='+news.ID">{{news.Title}}</a></div>
                        <div v-if="!(selected==4)" class="news_box_img"><a :href="'news_content?id='+news.ID"><img class="newsImg" :src="news.ImageURL" :alt="news.Title" /></a></div>
                        <div v-if="!(selected==4)" class="news_title" :title="news.Title"><a :href="'news_content?id='+news.ID">{{news.Title}}</a></div>
                        <div class="news_infowrap">
                            <div class="news_icon news_icon_blue" :class="getColorClass(news.NewsType)">{{news.NewsType}}</div>
                            <div class="news_day">{{news.DBCreate | moment}}</div>
                            <div class="editor">{{news.Editor}}</div>
                            <div class="news_box_content">{{news.Summery}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pageSelect" id="pageSelect"></div>
        <!-- <b-pagination size="md" :total-rows="id.Items.length" v-model="id.Page" :per-page="showPages" :first-text="''" :last-text="''" ></b-pagination> -->
        <topic-banners :special-edit-slides="id2"></topic-banners>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus, newsOrder} from './config.js'
import user from './user.js'
import filters from './filters.js'
import Like from './Like.vue'
import TopicBanners from './TopicBanners.vue'
import DropdownOrder from './DropdownOrder.vue'
import bPagination from 'bootstrap-vue/es/components/pagination/pagination'

const showPages = 10

export default {
  name: 'NewsItems',
  props: ["id", "id2","selected"],
  data () {
    return {
      showPages: showPages,
      selected: this.selected,
      newsOrder: newsOrder,
    }
  },
  methods: {
    ...user,
    goPage (page) {
        this.now = page
    },
    onChange () {
    },
    checkDate(news) {
        console.log("check Date")
    },
    getColorClass (newsType){
      switch(newsType){
          case "最新消息":
          return 'newsType1';
          break;
          case "專題企劃":
          return 'newsType2';
          break;
          case "網站活動":
          return 'newsType3';
          break;
          case "問卷投票":
          return 'newsType4';
          break;
          case "活動報導":
          return 'newsType5';
          break;
          default :
          return 'newsType1';
      }
    }
  },
  filters: {
    ...filters
  },
  computed: {
    interval () {
        let from = (this.id.Page-1)*this.showPages
        let to = this.id.Page*this.showPages
        let items = this.id.Comments.slice(from, to)
        return items
    },
  },
  components: {
    Like,
    TopicBanners,
    bPagination,
    DropdownOrder
    
  },
  mounted () {
    this.$watch('selected', function () {
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/NewsItems.vue